import React, { useState } from "react";
import FlashNewsGrid from "./FlashNewsGrid";
import FlashNewsForm from "./FlashNewsForm";

const EditFlashNews = () => {
  const [newsList, setNewsList] = useState([
    "Welcome to Trinity High School. Our Student Got National First Prize in JCI NLTS.",
  ]);
  const [view, setView] = useState("grid"); // 'grid' | 'create' | 'edit'
  const [editIndex, setEditIndex] = useState(null);

  const handleCreate = () => {
    setEditIndex(null);
    setView("create");
  };

  const handleEdit = (index) => {
    setEditIndex(index);
    setView("edit");
  };

  const handleDelete = (index) => {
    const updated = newsList.filter((_, i) => i !== index);
    setNewsList(updated);
  };

  const handleSubmit = (newsText) => {
    if (editIndex !== null) {
      const updated = [...newsList];
      updated[editIndex] = newsText;
      setNewsList(updated);
    } else {
      setNewsList([...newsList, newsText]);
    }
    setView("grid");
  };

  const handleCancel = () => {
    setView("grid");
  };

  return (
    <div className="container mt-4">
      {view === "grid" && (
        <FlashNewsGrid
          data={newsList}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onCreate={handleCreate}
        />
      )}
      {(view === "create" || view === "edit") && (
        <FlashNewsForm
          initialValue={view === "edit" ? newsList[editIndex] : ""}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default EditFlashNews;
